var disabledSpecificDays = ["8-09-2017", "5-10-2017", "5-01-2017", "12-25-2017", "4-14-2017", "6-25-2017", "9-01-2017", "10-18-2017", "1-28-2017", "1-27-2017", "2-16-2018", "2-17-2018", "2-18-2018", "2-19-2018"];
var errorText = "Please choose a delivery date.";
$(function(){
  initCartDatepicker();
})


initCartDatepicker = () => {
  var d = new Date();
  var _day = d.getDay();
  var newDate = new Date(d.setDate(d.getDate() + 1));
  var year = newDate.getFullYear(), month = newDate.getMonth() + 1, day = newDate.getDate();
  var timeNow = d.getHours();
  // console.log(_day);
  if (_day == 5 || _day == 6) {
    $("#selectDate").datepicker({
      minDate: +4,
      dateFormat: 'dd/mm/yy',
      beforeShowDay: disableSpecificDaysAndWeekends
    });
  }
  else {
    $("#selectDate").datepicker({
      minDate: +3,
      dateFormat: 'dd/mm/yy',
      beforeShowDay: disableSpecificDaysAndWeekends
    });
  }


//   $('#selectDate').datepicker('setDate', getAvailableDate(newDate))

}

checkSelectDate = () => {
  event.preventDefault();
  var _str = $('#selectDate').val();
  if (_str.length > 0) {
    $('.error-text').empty();
    $('#checkout').click();
  }
  else{
    $('.error-text').text(errorText);
  }
}

// Default related function datepicker
function getYMD(d) {
  const date = new Date(d)
  var year = date.getFullYear(), month = (date.getMonth() + 1), day = date.getDate()
  return `${month}-${day}-${year}`
}

function isDateDisabled(d) {
  const date = new Date(d)
  const day = date.getDay();
  if (day === 0) return true
  if (disabledSpecificDays.includes(getYMD(date))) return true
  if (new Date() > date) return true
  return false
}

function getAvailableDate(date) {
  let nextDate = new Date(date)
  while (isDateDisabled(nextDate)) {
    nextDate = new Date(nextDate.setDate(nextDate.getDate() + 1))
  }
  return nextDate
}

function disableSpecificDaysAndWeekends(d) {
  const date = new Date(d)
  var m = date.getMonth() + 1
  var d = date.getDate()
  var y = date.getFullYear();

  const day = date.getDay();
  if (disabledSpecificDays.includes(`${m}-${d}-${y}`)) {
    return [false]
  }
  if (new Date() > date) {
    return [false]
  }
  return [(day != 0)]
}
